module.exports = __webpack_public_path__ + "static/img/th_アセット 1@0.5x.8b51325.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/th_アセット 1@0.5x.jpg
// module id = QI0J
// module chunks = 1